/**
 * ホーム（/home）の画面の文（#226、2026-10-21 射場さん「ホームの圧縮」、docs/10 §9.2・§9.29）。
 * 題・カード・入金待ち・今月の実績・「？」の文はここに1か所。{customer}・{vendorQuote}・{vendor} は画面が t() で埋める（言葉の切替。営業力は「仕入先見積」）。
 * 状態の題は名詞だけ・「未〜」「〜待ち」でそろえる（未発行の見積／受注待ち／未請求／確認待ち／入金待ち）。0件の副題は「対象なし」
 */
/**
 * 左のメニューの組の見出し（#242、docs/94 B-7・★6）：受注＝お客様からお金をもらう仕事の書類（見積書・請求書・入金）、
 * 発注＝外注先・仕入先にお金を払う仕事の書類（{vendorQuote}・見積依頼・{order}・仕入）。広げたメニューだけに出す
 */
export const NAV_GROUP_MSG = { receive: "受注", order: "発注" } as const;

export const HOME_MSG = {
  /** ページの題（前は「今日やること」） */
  title: "本日の業務",
  /** 左のメニュー・戻るボタン・画面の名前（前は「今日」） */
  menu: "ホーム",
  /** 見出しの右の主ボタン（前は「新しい見積書」） */
  create: "見積書作成",
  /** カードの題（前は「見積を出す」「未受注の見積」「請求する」） */
  drafts: "未発行の見積",
  waiting: "受注待ち",
  toBill: "未請求",
  /** 前は「AI読み取り済みの{vendorQuote}」 */
  vendorReview: "確認待ちの{vendorQuote}",
  vendorFailed: "読み取れなかった{vendorQuote}",
  /** 0件のときの副題（前は「下書きはありません」・空） */
  none: "対象なし",
  /** カードの右の「表示 →」 */
  show: "表示",
  /** 「表示」の title（読み上げ） */
  showTitle: (title: string) => `${title}を表示`,
  /** 金額の前の言葉（前は「合わせて」） */
  total: "合計",
  /** 未発行の見積の副題：いちばん古い見積日からの日数（今日 − 見積日）。0日以下は「本日分のみ」 */
  oldest: (days: number, date: string) => (days <= 0 ? "本日分のみ" : `最長 ${days}日経過（${date}）`),
  /** 確認待ちの{vendorQuote}の副題：1件目の{project}名＋「ほか n 件」（1件なら名前だけ） */
  others: (first: string, rest: number) => (rest > 0 ? `${first} ほか ${rest} 件` : first),
  /** 未請求の副題の続き */
  toBillDrafts: (n: number) => `うち請求書の下書きあり ${n} 件`,
  vendorFailedN: (n: number) => `読み取れなかった{vendorQuote} ${n}件`,
  vendorReadingN: (n: number) => `AI読み取り中 ${n}件`,
  /** 入金待ち（前は「入金を待っている」） */
  awaiting: "入金待ち",
  /** 入金待ちの行の期限のチップ（前は「10月31日まで」） */
  due: (date: string) => `期限 ${date}`,
  noDue: "期限なし",
  /** 前は「残」 */
  balance: "残額",
  /** 前は「入金記録」 */
  record: "入金登録",
  awaitingAll: (n: number) => `未入金の請求書をすべて表示（${n}件）`,
  overdueSum: "うち期限超過",
  /** 今月の実績（前は「今月の数字」。カードを並べず1行の帯） */
  month: "今月の実績",
  lastMonth: "先月の実績",
  monthThis: "今月",
  monthLast: "先月",
  monthPick: "月を選ぶ",
  /** 帯の項目（前は「出した見積」「利益（受注した分）」） */
  issued: "見積発行",
  ordered: "受注",
  lost: "失注",
  profit: "利益",
  profitRate: (rate: number) => `利益率 ${rate}%`,
  costMissing: (n: number) => `仕入れ未入力 ${n}枚`,
  unpaid: "未入金",
  /** 見積が1枚も無いとき（まず1枚） */
  firstTitle: "まず1枚、見積書を作ってみましょう",
  firstBody: "{customer}の名前と{subject}、明細を数行。それだけで見積書のPDFが出ます。",
  loading: "読み込んでいます…",
  /** 見出しの「？」 */
  helpLabel: "本日の業務の説明",
  helpDecide: "「受注待ち」は、返事が来たら見積書の一覧で「受注」「失注」を押します。",
  helpFirst: "品目や単価の登録は要りません。書いたものは次から候補に出ます。会社名や住所は、出すときにお聞きします（会社名だけ要ります）。",
  helpCompanyName: "会社名は、はじめて見積書を出すときにお聞きします。",
  /** 入金待ちの「？」 */
  helpAwaiting: "発行した請求書のうち、まだ残額があるものです。お支払期限を過ぎたものが上に「期限超過 n日」の文字で出ます。{customer}から入金があったら「入金登録」を押します。",
  /** 今月の実績の「？」 */
  helpMonthLabel: "今月の実績の説明",
  helpMonth: "見積の数字です。金額は税込、利益だけ税抜。利益は、受注した見積の仕入れが全部入ると出ます（「仕入れ未入力」のあいだは出しません）。",
  helpMonthUnpaid: "未入金は、発行した請求書の残額の合計です（入金待ちと同じ数え方）。",
} as const;
